import TypeList from './typeList.view';

export default TypeList;
